import { render, staticRenderFns } from "./geographicDistrict.vue?vue&type=template&id=b8e85e3e&scoped=true&"
import script from "./geographicDistrict.vue?vue&type=script&lang=js&"
export * from "./geographicDistrict.vue?vue&type=script&lang=js&"
import style0 from "./geographicDistrict.vue?vue&type=style&index=0&id=b8e85e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e85e3e",
  null
  
)

export default component.exports